import React from "react";
import VehicleExemptionsTable from "./VehicleExemptionsTable";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const VehicleExemptions: React.FC = () => {
  return (
    <Stack direction="column" sx={{ height: "100%" }}>
      <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Stack direction="column" spacing={3} sx={{ flexGrow: 1 }}>
          <Box>
            <Typography variant={"h4"} fontWeight={600}>
              Vehicle Exemptions
            </Typography>
            <Typography variant={"subtitle1"} color={"text.disabled"} fontSize={"0.75rem"}>
              Vehicles exempt from payment and enforcement
            </Typography>
          </Box>
          <VehicleExemptionsTable />
        </Stack>
      </Container>
    </Stack>
  );
};

export default VehicleExemptions;
